import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import React, { useState } from "react";
import { toast } from "react-toastify";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import CoreButtonHoverIcon from "../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon";
import CoreModal from "../../../app/core/components/CoreModal/CoreModal";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
import {
  useEditServiceMutation,
  useGetOtherServicesQuery,
  useRemoveServiceMutation,
} from "../../api/admin/altriServiziApi";
import CreateService from "./CreateService";
import EditService from "./EditService";
import CoreDialog from "../../../app/core/components/CoreDialog/CoreDialog";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import { t } from "i18next";
import { Divider } from "@mui/material";

const AltriServiziPage = () => {
  const [openServiceCreateModal, setOpenServiceCreateModal] = useState(false);
  const [service, setService] = useState();
  const [openServiceEditModal, setOpenServiceEditModal] = useState(false);
  const [showDeleteServiceDialog, setShowDeleteServiceDialog] = useState(false);
  const [deleteService, setDeleteService] = useState();

  const { data, isLoading, refetch } = useGetOtherServicesQuery();
  const [removeService, { isLoading: isRemovingService }] =
    useRemoveServiceMutation();
  const [editService] = useEditServiceMutation();

  const handleRefecthDocuments = () => {
    refetch();
  };

  const handleOpenCreateModal = () => {
    setOpenServiceCreateModal(true);
  };

  const handleOpenEdit = (service) => {
    setService(service);
    setOpenServiceEditModal(true);
  };

  const handleCloseEdit = () => {
    setOpenServiceEditModal(false);
  };

  const handleOpenDialog = (service) => {
    setShowDeleteServiceDialog(true);
    setDeleteService(service);
  };

  const handleCloseDialog = () => {
    setShowDeleteServiceDialog(false);
    setDeleteService();
  };

  const handleCloseCreateModal = () => setOpenServiceCreateModal(false);

  const handleDeleteService = async (Id) => {
    await removeService({ Id })
      .then((res) => {
        if (res.data.Result !== 1) {
          toast.error(`Errore: ${res.data.Exception}`);
        } else {
          toast.success("Servizio rimosso");
        }
      })
      .catch(() => {
        toast.error("Errore inatteso durante la rimozione");
      })
      .finally(() => handleCloseDialog());
  };

  const handleEdit = async (service) => {
    const formData = { ...service, enabled: !service.enabled };
    try {
      await editService(formData);
      if (service.enabled) {
        toast.success("Servizio disattivo");
      } else if (!service.enabled) {
        toast.success("Servizio attivo");
      } else {
        toast.success("Servizio modificato");
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.Exception) {
        toast.error(`Impossibile modificare il servizio`);
        console.error("Eccezione durante la modifica del servizio");
      } else {
        toast.error("Impossibile modificare il servizio");
      }
    }
  };

  return (
    <div className="w-full">
      <CoreButtonHoverIcon
        onClick={handleRefecthDocuments}
        className="text-blue-500 m-1 flex flex-row space-x-2 border"
        testo={t("Refresh")}
        icon={<RefreshRoundedIcon className={`fill-blue-500`} />}
      />
      <CoreButtonHoverIcon
        className="text-blue-700 m-1"
        icon={<AddBoxRoundedIcon className={`fill-blue-700`} />}
        testo={t("Services")}
        onClick={handleOpenCreateModal}
      />
      {isLoading ? (
        <CoreSpinner />
      ) : (
        data?.Data?.items?.map((service) => (
          <>
            <div className="flex py-8 items-center space-x-12" key={service.id}>
              <div className="w-28">
                {service.iconUrl ? (
                  <img
                    src={service.iconUrl}
                    className="w-full h-full"
                    alt={service.name}
                  />
                ) : (
                  <p className="text-gray">Nessun logo</p>
                )}
              </div>
              <div className="w-6/12">
                <h3 className="m-0">{service.name}</h3>
                <p className="m-0">{service.description}</p>
                <div className="py-2 space-x-4">
                  <CoreButtonHoverIcon
                    testo="Modifica servizio"
                    className="text-primary my-1"
                    p={0}
                    onClick={() => handleOpenEdit(service)}
                  />

                  <CoreButtonHoverIcon
                    testo="Elimina"
                    className="text-danger m-1"
                    p={0}
                    onClick={() => handleOpenDialog(service)}
                  />
                </div>
                <p className="text-primary font-bold">{service.commission} €</p>
              </div>
              <CoreButton
                testo={service.enabled ? "Disattiva" : "Attiva"}
                className={service.enabled ? "btn-round-outline" : "btn-round"}
                onClick={() => handleEdit(service)}
              />
            </div>
            <Divider />
          </>
        ))
      )}
      <CoreModal
        width={1000}
        height={800}
        state={openServiceCreateModal}
        onClose={handleCloseCreateModal}
        component={<CreateService handleClose={handleCloseCreateModal} />}
      />
      <CoreModal
        width={1000}
        height={800}
        state={openServiceEditModal}
        onClose={handleCloseEdit}
        component={
          <EditService service={service} handleClose={handleCloseEdit} />
        }
      />
      <CoreDialog
        open={showDeleteServiceDialog}
        title={"Elimina operatore"}
        content={`Confermi di voler eliminare il servizio: "${deleteService?.name}"`}
        negativeButton={"No"}
        positiveButton={"Si"}
        handlePositive={() => handleDeleteService(deleteService.id)}
        closeDialog={handleCloseDialog}
        disabledButton={isRemovingService}
      />
    </div>
  );
};

export default AltriServiziPage;
